import { createSelector } from 'reselect'
import { parseQuery } from '@calendly/http-tools'

const calendarSelector = (state) => state.calendar

export const daySelector = createSelector(
  calendarSelector,
  (calendar) => calendar.day
)

export const monthShiftSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.monthShift
)

export const initialMonthParamSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.initialMonthParam
)

export const spotTimeForConflictsSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.conflictCheckQueue[0]
)

export const utcTodaySelector = createSelector(
  calendarSelector,
  (calendar) => calendar.today
)

export const selectedSpotsSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.selectedSpots
)

const hideDetails = ({ hide_event_type_details: hideEtDetails }) => parseInt(hideEtDetails, 10) === 1
export const hideEventTypeDetailsSelector = () => hideDetails(parseQuery(window.location.search))
